import React from 'react'
const contact = () => (
    <div>
      
      <div className="width-container">
          <div className="width-container-img-text d-flex align-items-center justify-content-center">
          <video autoPlay muted width="400px" loop>
        <source
          src={
            'https://res.cloudinary.com/ditqglru2/video/upload/v1742848908/final_with_bg_cut_mral5d.mov'
          }
          type="video/mp4"
        />
      </video>
            <p className="text-left" style={{marginLeft: '-20px'}}>For any information, question or curiosity, please contact me at: <a href="mailto:migueelbettencourt@gmail.com" style={{textDecoration: "none"}}><span className="font-weight-bold text-dark">migueelbettencourt@gmail.com </span></a></p>
          </div>
      </div>
    </div>
)

export default contact;



// WEBPACK FOOTER //
// ./src/pages/contact.js